function checkValue (target, action, source) {
  switch (source) {
    case 'oc':
      if (action === 'on') {
        break
      } else {
        target.oc_adp1 = false
        target.oc_adp2 = false
        target.ic1 = false
        target.ic1_adp1 = false
        target.ic1_adp2 = false
        target.ic2 = false
        target.ic2_adp1 = false
        target.ic2_adp2 = false
        target.ic3 = false
        target.ic3_adp1 = false
        target.ic3_adp2 = false
        target.ic4 = false
        target.ic4_adp1 = false
        target.ic4_adp2 = false
        break
      }
    case 'oc_adp1':
      if (action === 'on') {
        target.oc = true
        break
      } else {
        target.oc_adp2 = false
        break
      }
    case 'oc_adp2':
      if (action === 'on') {
        target.oc = true
        target.oc_adp1 = true
        break
      } else {
        break
      }
    case 'ic1':
      if (action === 'on') {
        target.oc = true
        break
      } else {
        target.ic1_adp1 = false
        target.ic1_adp2 = false
        target.ic2 = false
        target.ic2_adp1 = false
        target.ic2_adp2 = false
        target.ic3 = false
        target.ic3_adp1 = false
        target.ic3_adp2 = false
        target.ic4 = false
        target.ic4_adp1 = false
        target.ic4_adp2 = false
        break
      }
    case 'ic1_adp1':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        break
      } else {
        target.ic1_adp2 = false
        break
      }
    case 'ic1_adp2':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic1_adp1 = true
        break
      } else {
        break
      }
    case 'ic2':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        break
      } else {
        target.ic2_adp1 = false
        target.ic2_adp2 = false
        target.ic3 = false
        target.ic3_adp1 = false
        target.ic3_adp2 = false
        target.ic4 = false
        target.ic4_adp1 = false
        target.ic4_adp2 = false
        break
      }
    case 'ic2_adp1':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        break
      } else {
        target.ic2_adp2 = false
        break
      }
    case 'ic2_adp2':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        target.ic2_adp1 = true
        break
      } else {
        break
      }
    case 'ic3':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        break
      } else {
        target.ic3_adp1 = false
        target.ic3_adp2 = false
        target.ic4 = false
        target.ic4_adp1 = false
        target.ic4_adp2 = false
        break
      }
    case 'ic3_adp1':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        target.ic3 = true
        break
      } else {
        target.ic3_adp2 = false
        break
      }
    case 'ic3_adp2':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        target.ic3 = true
        target.ic3_adp1 = true
        break
      } else {
        break
      }
    case 'ic4':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        target.ic3 = true
        break
      } else {
        target.ic4_adp1 = false
        target.ic4_adp2 = false
        break
      }
    case 'ic4_adp1':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        target.ic3 = true
        target.ic4 = true
        break
      } else {
        target.ic4_adp2 = false
        break
      }
    case 'ic4_adp2':
      if (action === 'on') {
        target.oc = true
        target.ic1 = true
        target.ic2 = true
        target.ic3 = true
        target.ic4 = true
        target.ic4_adp1 = true
        break
      } else {
        break
      }
  }
}
module.exports = checkValue
